import { render, staticRenderFns } from "./TopProductCategories.vue?vue&type=template&id=631390ba"
import script from "./TopProductCategories.vue?vue&type=script&lang=js"
export * from "./TopProductCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports